export default __webpack_public_path__ + "static/media/power.6312948c.svg";